export const iconFontAwesomeUsersPeoplePersonCircleMinus = (
	<i className="fa-solid fa-person-circle-minus"></i>
);
